import axios from "axios";
const API_URL = process.env.REACT_APP_SERVER + "/api/auth/";

class AuthService {

  login(username) {
    return axios.post(API_URL + "login", { username: username }).then((response) => {
      let data = response.data;
      data.prolific_id = username;
      data.imgSrc = 1;
      Object.defineProperty(data, "avatarColor", Object.getOwnPropertyDescriptor(data, "color"));
      delete data["color"];
      if (data.accessToken) {
        window.parent.localStorage.setItem("user", JSON.stringify(data));
      }
      return data;
    });
  }

  // Qualtrics entry point: Qualtrics ID (the username), Prolific ID and group
  // come from the entry link, no password. Auto-creates the participant on
  // first use.
  enterWithId(qualtricsId, prolificId, group) {
    return axios.post(API_URL + "enter", { qualtricsId, prolificId, group: String(group) }).then((response) => {
      let data = response.data;
      data.prolific_id = prolificId;
      data.imgSrc = 1;
      Object.defineProperty(data, "avatarColor", Object.getOwnPropertyDescriptor(data, "color"));
      delete data["color"];
      if (data.accessToken) {
        window.parent.localStorage.setItem("user", JSON.stringify(data));
      }
      return data;
    });
  }
}

const authService = new AuthService()
export default authService;
